import Vue from 'vue'
import Router from 'vue-router'

// pages
import Room from '@/components/pages/Room.vue'
import Thanks from '@/components/pages/Thanks.vue'

// errors
import NotFound from '@/components/pages/errors/NotFound.vue'

Vue.use(Router)

const routes = [
  { path: '/thanks', name: 'thanks', component: Thanks },
  { path: '/:roomName', name: 'room', component: Room },
  { path: '*', name: 'notFound', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
